import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import { AiFillGithub } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              I’m a passionate full-stack developer who loves building dynamic
              web and cross-platform solutions that solve real-world problems!
              🚀
              <br />
              <br />I specialize in
              <i>
                <b className="purple">
                  {" "}
                  React.js, Python, Django, JavaScript, and TypeScript{" "}
                </b>
              </i>{" "}
              — along with modern web & backend technologies.
              <br />
              <br />
              My expertise includes developing&nbsp;
              <i>
                <b className="purple">full-stack applications</b> with React
                frontends and Python/Django backends,
              </i>
              &nbsp;integrating REST APIs, and working with
              <b className="purple"> scalable database solutions</b>.
              <br />
              <br />
              While my core focus is web development, I also explore&nbsp;
              <b className="purple">mobile-friendly experiences</b> using React
              Native to extend solutions seamlessly across platforms.
              <br />
              <br />
              Currently, I’m sharpening my skills in&nbsp;
              <b className="purple">end-to-end application architecture</b> —
              from intuitive UIs to secure, high-performance backends.
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <img src={myImg} className="img-fluid" alt="avatar" />
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/JamshaidAhmedd"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://linkedin.com/in/Jamshaidahmed"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
